import { BehaviorSubject } from "rxjs";
import store from "../state/store";

const store$ = new BehaviorSubject({});

store.subscribe(() => store$.next(store.getState()));

export default store$;
